export const LINEAR_REGRESSION = 'linear-regression';
